module.exports = "/images/hand-w.svg?e8025789ae93a70c104ed79168605aba";